import { httpClient } from '@/services/http/httpClient'

export type UpdateCommentProps = {
  commentId: string
  title: string
  comment: string
  attachment?: File
  subCommentId?: string
  projectId: string
}

export async function updateComment({
  commentId,
  comment,
  attachment,
  subCommentId,
  title,
  projectId,
}: UpdateCommentProps) {
  const payload = new FormData()
  payload.append('comment', comment)
  payload.append('subCommentId', subCommentId || '')
  payload.append('title', title)

  if (attachment) {
    payload.append('file', attachment)
  }

  await httpClient.put(
    `/projects/project-comments/${projectId}/${commentId}`,
    payload,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  )
}
